import { render, staticRenderFns } from "./PhoneDropDown.vue?vue&type=template&id=507e9473&scoped=true"
import script from "./PhoneDropDown.vue?vue&type=script&lang=js"
export * from "./PhoneDropDown.vue?vue&type=script&lang=js"
import style0 from "./PhoneDropDown.vue?vue&type=style&index=0&id=507e9473&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507e9473",
  null
  
)

export default component.exports